import { atom, atomFamily, selectorFamily } from 'recoil';
import { AgreementsService } from 'api';
export const getAgreementByIdRequestIdState = atom({
  key: 'getAgreementsByIdRequestIdState',
  default: 0
});
export const getAgreementById = selectorFamily({
  key: 'getAgreementById',
  get: agreementId => async ({
    get
  }) => {
    get(getAgreementByIdRequestIdState);
    if (!agreementId) return {};
    try {
      return await AgreementsService.getAgreementById({
        agreementId
      });
    } catch (e) {
      console.error(e);
    }
    return {};
  }
});
export const getAgreementAtom = atomFamily({
  key: 'getAgreementAtom',
  default: agreementId => getAgreementById(agreementId)
});